import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { usePublisherEdit } from '@/module/Publisher/model/PublisherQuery';
import { PublisherSchema, defaultPublisherValues, publisherSchema } from '@/module/Publisher/model/PublisherSchema';

import { useAppNotification } from '@feature/utils';

import { PublisherForm } from './PublisherForm';
import { Publisher } from './model/PublisherTypes';

interface PublisherEditProps {
  publisher: Publisher;
}

const convert = (publisher: Publisher): PublisherSchema => ({
  ...publisher,
});

export function PublisherEdit(props: PublisherEditProps) {
  const { publisher } = props;
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = usePublisherEdit(publisher.id);

  const notification = useAppNotification();
  const onSubmit = (values: PublisherSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: notification.success,
    });
  };

  const values = useMemo(() => convert(publisher), [publisher]);
  const navigate = useNavigate();

  return (
    <PublisherForm
      title={t('publishers.form.title.edit')}
      schema={publisherSchema}
      defaultValues={defaultPublisherValues}
      isError={isError}
      isSuccess={isSuccess}
      values={values}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
